import { render } from "./ImageComponentAnimate.vue?vue&type=template&id=1a7c2b2a"
import script from "./ImageComponentAnimate.vue?vue&type=script&lang=js"
export * from "./ImageComponentAnimate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__